// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3tODQ","inputWrap":"Table_inputWrap__1KrFc","col":"Table_col__5nEA2","bmiTooltip":"Table_bmiTooltip__3UZDo"};